import ModuleOneReflection from "../../../../src/components/forms/ModuleOneReflection";
import * as React from 'react';
export default {
  ModuleOneReflection,
  React
};